const getters = {
  list: state => state.list,
  isLoading: state => state.isLoading,
  isUploading: state => state.isUploading,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
};
export default getters;
